import React, { useState, useEffect } from "react";

const ComponentTypeForm = ({
  loading,
  closeModal,
  onSubmit,
  initialValues,
  errors = {}, // Added errors prop to display validation messages
}) => {
  // const [formData, setFormData] = useState(initialValues);
  const [formData, setFormData] = useState(() => ({
    ...initialValues,
    is_active: initialValues.is_active === '1' || initialValues.is_active === 1, // true if 1, false if 0
  }));

  useEffect(() => {
    setFormData({
      ...initialValues,
      is_active: initialValues.is_active === '1' || initialValues.is_active === 1,
    });
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const submissionData = new FormData(); // Use FormData for file upload
    submissionData.append("name", formData.name);
    submissionData.append("code", formData.code);
    submissionData.append("description", formData.description);
    submissionData.append("category", formData.category);
    submissionData.append("display_order", formData.display_order);
    submissionData.append("is_active", formData.is_active ? '1' : '0'); // Send 0 or 1 instead of true/false

    onSubmit(submissionData); // Pass the FormData to the parent onSubmit handler
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 font-poppins">
      {/* Name field */}
      <div>
          <label htmlFor="name" className="block dark:text-white text-sm font-medium text-gray-700">
          Name
          </label>
          <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
              errors.name ? "border-red-500" : "border-gray-300"
          }`}
          />
          {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name}</p>
          )}
      </div>

      {/* Code Field */}
      <div>
          <label htmlFor="code" className="block dark:text-white text-sm font-medium text-gray-700">
          Code
          </label>
          <input
          type="text"
          id="code"
          name="code"
          value={formData.code}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
              errors.code ? "border-red-500" : "border-gray-300"
          }`}
          />
          {errors.code && (
            <p className="text-red-500 text-sm mt-1">{errors.code}</p>
          )}
      </div>
      
      {/* Category Field */}
      <div>
          <label htmlFor="category" className="block dark:text-white text-sm font-medium text-gray-700">
          Category
          </label>
          <input
          type="text"
          id="category"
          name="category"
          value={formData.category}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
              errors.category ? "border-red-500" : "border-gray-300"
          }`}
          />
          {errors.category && (
            <p className="text-red-500 text-sm mt-1">{errors.category}</p>
          )}
      </div>

      {/* Display Order Field */}
      <div>
          <label htmlFor="display_order" className="block dark:text-white text-sm font-medium text-gray-700">
          Display Order
          </label>
          <input
          type="number"
          id="display_order"
          name="display_order"
          value={formData.display_order}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
              errors.display_order ? "border-red-500" : "border-gray-300"
          }`}
          />
          {errors.display_order && (
            <p className="text-red-500 text-sm mt-1">{errors.display_order}</p>
          )}
      </div>

      {/* Description Field */}
      <div>
          <label htmlFor="description" className="block dark:text-white text-sm font-medium text-gray-700">
          Description
          </label>
          <textarea
          type="text"
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
              errors.description ? "border-red-500" : "border-gray-300"
          }`}
          />
          {errors.description && (
            <p className="text-red-500 text-sm mt-1">{errors.description}</p>
          )}
      </div>

      {/* Is Active Field */}
      <div className="flex items-center">
          <input
          type="checkbox"
          id="is_active"
          name="is_active"
          checked={formData.is_active}
          onChange={handleChange}
          className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <label htmlFor="is_active" className="ml-2 block text-sm font-medium text-gray-700 dark:text-white">
          Is Active
          </label>
      </div>

      {/* Form Actions */}
      <div className="flex justify-end items-center gap-2">
          <button
          type="button"
          onClick={closeModal}
          className="px-6 py-2 font-medium text-black hover:bg-gray-200 dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md"
          >
          Cancel
          </button>
          <button
          type="submit"
          className="flex items-center gap-2 px-8 py-2 font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
          {initialValues.id ? "Update" : "Add"}
          {loading && (
              <svg
              className="animate-spin h-5 w-5 ml-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              >
              <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
              ></circle>
              <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
              </svg>
          )}
          </button>
      </div>
    </form>
  );
};

export default ComponentTypeForm;
